import { useState } from "react";

function usePagination({
	initialPerPage = 20,
	initialPage = 1,
	initialTotal = 0,
	initialSort = "desc",
	initialSortKey = "id",
}) {
	const [pagination, setPagination] = useState({
		perPage: initialPerPage,
		page: initialPage,
		total: initialTotal,
		sort: initialSort,
		sortKey: initialSortKey,
	});

	const setPaginationPerPage = (perPage) => {
		setPagination((prev) => ({ ...prev, perPage }));
	};

	const setPaginationPage = (page) => {
		setPagination((prev) => ({ ...prev, page }));
	};

	const setPaginationTotal = (total) => {
		setPagination((prev) => ({ ...prev, total }));
	};

	const setPaginationSort = (sort) => {
		setPagination((prev) => ({ ...prev, sort }));
	};

	const setPaginationSortKey = (sortKey) => {
		setPagination((prev) => ({ ...prev, sortKey }));
	};

	return {
		pagination,
		setPaginationPerPage,
		setPaginationPage,
		setPaginationTotal,
		setPaginationSort,
		setPaginationSortKey,
	};
}

export default usePagination;
